import React from "react";
import "../../tailwind.css";
import { IonImg, IonItem } from "@ionic/react";
import { IProgressCheckButton } from "../../types/ProgressCheckButton.types";
import { CommentHelpers } from "../../helpers/CommentHelper";
import { Button_Disclosure_Right_Grey } from "../../images/images";
import { EvidenceHelpers } from "../../helpers/EvidenceHelper";
import { StylingUtils } from "../../helpers/stylingUtils";
import classNames from "classnames";

const ProgressCheckButton: React.FC<IProgressCheckButton> = (props) => {
  return (
    <IonItem
      button
      className="preceptee-item-button flex flex-row !justify-between items-center"
      detail={false}
      onClick={props.buttonPressed}
    >
      <div className="min-h-[50px] w-full flex flex-row !justify-between items-center py-[8px]">
        <div className="flex flex-col flex-[-1]">
          <div className="text-[15px] leading-[1.33] tracking-[-0.3px] text-grey-90">{props.title}</div>
          {props.newCommentCount && props.newCommentCount > 0 ? (
            <div className="text-[11px] font-medium leading-[1.27] text-cta-red">
              {CommentHelpers.getCommentCountText(props.newCommentCount)}
            </div>
          ) : (
            typeof props.evidenceCount === "number" &&
            props.evidenceCount > 0 && (
              <div className="text-[11px] font-medium leading-[1.27] text-grey-60">
                {EvidenceHelpers.getEvidenceCountText(props.evidenceCount)}
              </div>
            )
          )}
        </div>
        <div className="flex flex-row items-center ml-[8px] flex-shrink-0">
          {/*
          bg-grey-30
          bg-orange-20
          bg-green-background
          bg-cta-red
          bg-light-blue
          */}
          {props.progressLabel && (
            <div
              className={classNames(
                "flex shrink-0 items-center px-[8px] py-[2.25] justify-center h-20px rounded-[10px]",
                StylingUtils.getProgressStatusBackgroundColor(props.progressLabel.status)
              )}
            >
              {/**
               * text-grey-60
               * text-orange-text
               * text-green-text
               * text-white
               * text-cta-blue
               */}
              <div
                className={classNames(
                  "h-[20px] leading-[20px] text-[13px] my-[2.25] font-semibold",
                  StylingUtils.getProgressStatusTextColor(props.progressLabel.status)
                )}
              >
                {props.progressLabel.label}
              </div>
            </div>
          )}
          <IonImg
            className="w-24px h-24px min-w-[24px] min-h-[24px] mr-[-5px] flex flex-[-1]"
            src={Button_Disclosure_Right_Grey}
          />
        </div>
      </div>
    </IonItem>
  );
};

export default ProgressCheckButton;
